import DdSubHeader from '@/components/DdSubHeader'
import DdCodeTextBox from '@/components/DdCodeTextBox'
import DdDateBox from '@/components/DdDateBox'
import DdTextBox from '@/components/DdTextBox'
import DdRadioButton from '@/components/DdRadioButton'
import DdDefaultButton from '@/components/DdDefaultButton'
import DdNarrowDownTextBox from '@/components/DdNarrowDownTextBox'
import DdRowCountBox from '@/components/DdRowCountBox'
import DdDataTable from '@/components/DdDataTable'
import DdFooterButton from '@/components/DdFooterButton'

import flowMixin from '@/mixins/flowMixins'
import { mapGetters } from 'vuex'
import header from '@/ddv2.library/header'
import filter from '@/rahmen/utils/filters'
import date from '@/ddv2.library/date'
import validators from '@/rahmen/validators'

export default {
  name: 'VwCHacchuIchiran',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    conditions: {
      hacchuEigyoshoCd: '',
      hacchuStartYmdString: '',
      hacchuEndYmdString: '',
      nyuryokuTantoshaCd: '',
      hacchusakiCd: '',
      sagyoYoteiStartYmdString: '',
      sagyoYoteiEndYmdString: '',
      chumonNo: '',
      ninushiCd: '',
      hatsuchiCd: '',
      oroshisakiCd: '',
      chakuchiCd: '',
      shiharaiStatus: ''
    },
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstJininHeaders: header.mstJininHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    modeKengen: 0,
    page: 1
  }),
  components: {
    DdSubHeader,
    DdCodeTextBox,
    DdDateBox,
    DdTextBox,
    DdRadioButton,
    DdDefaultButton,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdDataTable,
    DdFooterButton
  },
  computed: {
    ...mapGetters({
      eigyoshoList: 'DDMasters/mstEigyosho',
      eigyoshoJininList: 'DDMasters/vwCMstEigyoshoJininList',
      torihikisakiList: 'DDMasters/mstTorihikisaki',
      hacchakuchiList: 'DDMasters/mstHacchakuchi'
    }),
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.hacchuYmd = filter.dateFormatter(elem.hacchuYmd)
        if (elem.hacchusakiKbn === '1') {
          elem.hacchusakiKbn = '傭車先'
        } else if (elem.hacchusakiKbn === '2') {
          elem.hacchusakiKbn = '仕入先'
        }
        if (elem.shiharaiTomeFlg != null) { elem.shiharaiTomeFlg = elem.shiharaiTomeFlg ? '支払対象外' : '支払対象' }
        if (elem.ikkatsuShiharaiFlg != null) { elem.ikkatsuShiharaiFlg = elem.ikkatsuShiharaiFlg ? '一括支払' : '個別支払' }
        if (elem.shiharaiYoteiYmd) { elem.shiharaiYoteiYmd = filter.dateFormatter(elem.shiharaiYoteiYmd) }
        if (elem.unchinKakuteiFlg != null) { elem.unchinKakuteiFlg = elem.unchinKakuteiFlg ? '確定' : '未確定' }
        if (elem.shiharaiZumiFlg != null) { elem.shiharaiZumiFlg = elem.shiharaiZumiFlg ? '支払済' : '未支払' }
        elem.shiharaiKingaku = filter.numericFormatter(elem.shiharaiKingaku) + '円'
        elem.hacchuMeisaiKingaku = filter.numericFormatter(elem.hacchuMeisaiKingaku) + '円'
        if (elem.sagyoYoteiYmd) { elem.sagyoYoteiYmd = filter.dateFormatter(elem.sagyoYoteiYmd) }
        if (elem.hatsuchiYmd) { elem.hatsuchiYmd = filter.dateFormatter(elem.hatsuchiYmd) }
        if (elem.hatsuchiHms) { elem.hatsuchiHms = (elem.hatsuchiHms).slice(0, 5) }
        if (elem.chakuchiYmd) { elem.chakuchiYmd = filter.dateFormatter(elem.chakuchiYmd) }
        if (elem.chakuchiHms) { elem.chakuchiHms = (elem.chakuchiHms).slice(0, 5) }
        if (elem.yoteiSagyoJikan) { elem.yoteiSagyoJikan = filter.minToTimeFormatter(elem.yoteiSagyoJikan) }
        if (elem.warimashiTaishoJikan) { elem.warimashiTaishoJikan = filter.minToTimeFormatter(elem.warimashiTaishoJikan) }
        if (elem.warimashiJikanTanka) { elem.warimashiJikanTanka = filter.numericFormatter(elem.warimashiJikanTanka) + '円' }
        if (elem.yoteiSokoKyori) { elem.yoteiSokoKyori = filter.numericFormatter(elem.yoteiSokoKyori) + 'km' }
        if (elem.warimashiTaishoKyori) { elem.warimashiTaishoKyori = filter.numericFormatter(elem.warimashiTaishoKyori) + 'km' }
        if (elem.warimashiKyoriTanka) { elem.warimashiKyoriTanka = filter.numericFormatter(elem.warimashiKyoriTanka) + '円' }

        return elem
      })
    },
    filteredHacchuEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    filteredNyuryokuTantoshaList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoJininList.map((elem) => {
        elem.jomuFlg = elem.jomuFlg ? '乗務員' : ''
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn === '01'
      })
    },
    filteredHacchusakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && (elem.shiiresakiFlg || elem.yoshasakiFlg === true)
      })
    },
    filteredTokuisakiList () {
      const target = filter.dateFormatter(new Date())
      return this.torihikisakiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.tokuisakiFlg === true
      })
    },
    filteredMstHacchakuchiList () {
      const target = filter.dateFormatter(new Date())
      return this.hacchakuchiList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    CreateButtonDisp () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmsteigyoshojininlist', 'msttorihikisaki', 'msthacchakuchi'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('VwCHacchuIchiran.defineHeaderPromise')
            self.headers = [
              { text: '発注番号', value: 'hacchuNo' },
              { text: '発注日', value: 'hacchuYmd', align: 'center' },
              { text: '発注営業所', value: 'hacchuEigyoshoNm' },
              { text: '注文番号', value: 'chumonNo' },
              { text: '発注先区分', value: 'hacchusakiKbn' },
              { text: '発注先', value: 'hacchusakiNm' },
              { text: '支払止', value: 'shiharaiTomeFlg' },
              { text: '支払区分', value: 'ikkatsuShiharaiFlg' },
              { text: '支払予定日', value: 'shiharaiYoteiYmd', align: 'center' },
              { text: '運賃確定状況', value: 'unchinKakuteiFlg' },
              { text: '支払状況', value: 'shiharaiZumiFlg', filterable: false },
              { text: '支払金額', value: 'shiharaiKingaku', align: 'end' },
              { text: '発注契約番号', value: 'hacchuKeiyakuNo', align: 'center' },
              { text: '発注明細番号', value: 'hacchuMeisaiNo' },
              { text: '発注明細金額', value: 'hacchuMeisaiKingaku', align: 'end', filterable: false },
              { text: '作業希望日', value: 'sagyoYoteiYmd', align: 'center' },
              { text: '荷主', value: 'ninushiNm' },
              { text: '発地', value: 'hatsuchiNm' },
              { text: '発日付', value: 'hatsuchiYmd', align: 'center' },
              { text: '発時刻', value: 'hatsuchiHms', align: 'center' },
              { text: '発時刻備考', value: 'hatsuchiHmsBiko' },
              { text: '卸先', value: 'oroshisakiNm' },
              { text: '着地', value: 'chakuchiNm' },
              { text: '着日付', value: 'chakuchiYmd', align: 'center' },
              { text: '着時刻', value: 'chakuchiHms', align: 'center' },
              { text: '着時刻備考', value: 'chakuchiHmsBiko' },
              { text: '予定作業時間', value: 'yoteiSagyoJikan', align: 'center' },
              { text: '割増対象時間', value: 'warimashiTaishoJikan', align: 'center' },
              { text: '割増時間単価', value: 'warimashiJikanTanka', align: 'end' },
              { text: '予定作業距離', value: 'yoteiSokoKyori', align: 'end' },
              { text: '割増対象距離', value: 'warimashiTaishoKyori', align: 'end' },
              { text: '割増距離単価', value: 'warimashiKyoriTanka', align: 'end' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            const d = new Date()
            self.conditions = {
              hacchuEigyoshoCd: '',
              hacchuStartYmdString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
              hacchuEndYmdString: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
              nyuryokuTantoshaCd: '',
              hacchusakiCd: '',
              sagyoYoteiStartYmdString: '',
              sagyoYoteiEndYmdString: '',
              chumonNo: '',
              ninushiCd: '',
              hatsuchiCd: '',
              oroshisakiCd: '',
              chakuchiCd: '',
              shiharaiStatus: '01'
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('VwCHacchuIchiran.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('VwCHacchuIchiran.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('VwCHacchuIchiran.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('VwCHacchuIchiran.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value.conditions || {}
            self.searchText = c.cache.value.searchText || ''
            self.rows = c.cache.value.rows || []
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('VwCHacchuIchiran.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }
            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2plod0010/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            shiharaiStatus: self.conditions.shiharaiStatus
          }
        }
      }
      this.search(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      console.log('clear pushed')
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            const d = new Date()
            this.conditions = {
              hacchuEigyoshoCd: '',
              hacchuStartYmdString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
              hacchuEndYmdString: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
              nyuryokuTantoshaCd: '',
              hacchusakiCd: '',
              sagyoYoteiStartYmdString: '',
              sagyoYoteiEndYmdString: '',
              chumonNo: '',
              ninushiCd: '',
              hatsuchiCd: '',
              oroshisakiCd: '',
              chakuchiCd: '',
              shiharaiStatus: '01'
            }
            this.searchText = ''
            this.rows = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onRowClick: function (e) {
      console.log(e)
      this.Effects.loadStart()

      this.transition(0, { id: e.id })
    },
    onCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/VwCD2plod0010/download', this.conditions)
        .then((data) => {
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.click()
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      if (!this.conditions.hacchuEigyoshoCd && !this.conditions.hacchuStartYmdString && !this.conditions.hacchuEndYmdString && !this.conditions.nyuryokuTantoshaCd && !this.conditions.hacchusakiCd && !this.conditions.sagyoYoteiStartYmdString && !this.conditions.sagyoYoteiEndYmdString && !this.conditions.chumonNo && !this.conditions.ninushiCd && !this.conditions.hatsuchiCd && !this.conditions.oroshisakiCd && !this.conditions.chakuchiCd && this.conditions.shiharaiStatus === '01') {
        this.setInvalidSummaryMessage('COME0026')
        return false
      }
      if (this.conditions.hacchuStartYmdString && this.conditions.hacchuEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.hacchuStartYmdString, this.conditions.hacchuEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.hacchuStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.hacchuEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      if (this.conditions.sagyoYoteiStartYmdString && this.conditions.sagyoYoteiEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.sagyoYoteiStartYmdString, this.conditions.sagyoYoteiEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.sagyoYoteiStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.sagyoYoteiEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      return true
    }
  }
}
